export const ViewTab = {
    GIGS: 'gigs',
    SELLERS: 'sellers',
};
